/**
 * Shared carrier service level definitions used across
 * EcommerceConnectionComponent, NetworkSettingsComponent,
 * and ChangePackagesComponent.
 */
export const CARRIER_SERVICE_LEVELS = [
  { ID: 'UPS_GROUND', carrier: 'UPS', serviceLevel: 'GROUND', brandedPackagingRequired: false },
  { ID: 'USPS_PRIORITY_FLAT', carrier: 'USPS', serviceLevel: 'PRIORITY_FLAT', brandedPackagingRequired: true },
  { ID: 'USPS_MEDIA', carrier: 'USPS', serviceLevel: 'MEDIA', brandedPackagingRequired: false },
  { ID: 'USPS_PRIORITY', carrier: 'USPS', serviceLevel: 'PRIORITY', brandedPackagingRequired: false },
  { ID: 'USPS_FIRSTCLASS', carrier: 'USPS', serviceLevel: 'FIRSTCLASS', brandedPackagingRequired: false },
  { ID: 'USPS_PARCEL', carrier: 'USPS', serviceLevel: 'PARCEL', brandedPackagingRequired: false },
  { ID: 'UPS_FREIGHT', carrier: 'UPS', serviceLevel: 'FREIGHT', brandedPackagingRequired: false },
  { ID: 'UPS_FREIGHTNODOCK', carrier: 'UPS', serviceLevel: 'FREIGHTNODOCK', brandedPackagingRequired: false },
  { ID: 'UPS_NEXTDAYAIR', carrier: 'UPS', serviceLevel: 'NEXTDAYAIR', brandedPackagingRequired: false },
  { ID: 'UPS_NEXTDAYAIRSAVER', carrier: 'UPS', serviceLevel: 'NEXTDAYAIRSAVER', brandedPackagingRequired: false },
  { ID: 'UPS_NEXTDAYAIREARLYAM', carrier: 'UPS', serviceLevel: 'NEXTDAYAIREARLYAM', brandedPackagingRequired: false },
  { ID: 'UPS_2NDDAYAIR', carrier: 'UPS', serviceLevel: '2NDDAYAIR', brandedPackagingRequired: false },
  { ID: 'UPS_2NDDAYAIRAM', carrier: 'UPS', serviceLevel: '2NDDAYAIRAM', brandedPackagingRequired: false },
  { ID: 'UPS_3DAYSELECT', carrier: 'UPS', serviceLevel: '3DAYSELECT', brandedPackagingRequired: false },
  { ID: 'INPLANT_PICKUP', carrier: 'INPLANT', serviceLevel: 'PICKUP', brandedPackagingRequired: false }
];


